import React from 'react';
import { Box } from '@mui/material';
import ModernHeroSection from '../components/ModernHeroSection';
import InteractiveFeatureCards from '../components/InteractiveFeatureCards';
import TechnologyShowcase from '../components/TechnologyShowcase';
import ConversionCTA from '../components/ConversionCTA';

const HomePage: React.FC = () => {
  return (
    <Box sx={{
      minHeight: '100vh'
    }}>
      {/* Modern Hero Section */}
      <ModernHeroSection />

      {/* Interactive Feature Cards */}
      <InteractiveFeatureCards />

      {/* Technology Showcase with Data Visualization */}
      <TechnologyShowcase />

      {/* Conversion-Optimized CTA with Testimonials */}
      <ConversionCTA />
    </Box>
  );
};

export default HomePage;

